import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nk-shared-contact-menu-mobile',
  templateUrl: './contact-menu-mobile.component.html',
  styleUrls: ['./contact-menu-mobile.component.scss']
})
export class ContactMenuMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
